import * as React from "react";
import  { useState, useEffect } from 'react';
import Box from "@mui/material/Box";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import PeopleIcon from "@mui/icons-material/People";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Link, useLocation } from "react-router-dom";
import Logo from "../../Assets/logo.jpg";
import GroupIcon from '@mui/icons-material/Group';
import EmailIcon from '@mui/icons-material/Email';
import ChatIcon from '@mui/icons-material/Chat';
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';
import SchoolIcon from '@mui/icons-material/School';
import KeyboardIcon from '@mui/icons-material/Keyboard';
import SideBarNavBar from "../SideBarNavBar/SideBarNavBar";
import PostAddIcon from '@mui/icons-material/PostAdd';
import DashboardIcon from '@mui/icons-material/Dashboard';
import axios from 'axios';
import Collapse from "@mui/material/Collapse";
import { ExpandLess, ExpandMore } from "@mui/icons-material";


export default function AdminSidebar() {
  const [state, setState] = React.useState({
    left: false,
    top: false,
  }); 

  const isLargeScreen = useMediaQuery("(min-width:1441px)");
  const location = useLocation();

    const userDataString = localStorage.getItem("Login_User_Community_All_Data");
    const userData = JSON.parse(userDataString);
    const token = userData.token;
    //const [state, setState] = useState({ left: false });
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [submenuOpen, setSubmenuOpen] = useState({});
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    
    const fetchCategories = async () => {
      try {
        const roleId = userData.role;    //Changed for duanamically get Role for provider 3; 
        const response = await axios.get(
          `${API_BASE_URL}/api/getCategoriesByRoleId/${roleId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`, // Pass the token for authenticated API calls
            },
          }
        );
  
        // Directly setting the fetched categories and subcategories
        setCategories(response.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching categories:", error);
        setLoading(false);
      }
    };
  
    useEffect(() => {
      fetchCategories();
    }, []);
  

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const toggleSubmenu = (key) => {
    setSubmenuOpen((prevState) => ({
      ...prevState,
      [key]: !prevState[key],
    }));
  };

  const list = (anchor) => (
    <Box
      sx={{
        width: anchor === "top" || anchor === "bottom" ? "auto" : 250,
        background: "#FFFFFF",
        height: "100%",
        // borderTopRightRadius: isLargeScreen ? 30 : 0,
        // borderBottomRightRadius: 30,
        overflowX: "hidden", 
      }}
      role="presentation"
      onClick={isLargeScreen ? null : toggleDrawer(anchor, false)}
      onKeyDown={isLargeScreen ? null : toggleDrawer(anchor, false)}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: 65
        }}
      >
        <img src={Logo} alt="Inspire Community" style={{ maxWidth: "100%", maxHeight: 55 }} />
      </Box>
      <Divider />
      <List>
        {[
          { text: "Dashboard", icon: <DashboardIcon sx={{ fontSize: 30, color: 'black' }}  />, path: "/admin-user/admin-dashboard" },
          { text: "All Users", icon: <GroupIcon sx={{ fontSize: 30, color: 'black' }} />, path: "/admin-user/approval-pending-user" },
          { text: "Role", icon: <PostAddIcon sx={{ fontSize: 30, color: 'black' }} />, path: "/admin-user/role-assign" },
          { text: "Category SubCategory", icon: <PostAddIcon sx={{ fontSize: 30, color: 'black' }} />, path: "/admin-user/category-subcategory" },
          
        ].map((item) => (
          <ListItem key={item.text} disablePadding 
            sx={{
                  backgroundColor: location.pathname === item.path ? 'rgba(0,0,0,0.2)' : 'inherit', width:"100%",
                   color:"black",
                  '&:hover': {
                  backgroundColor: 'rgba(0,0,0,0.2)',
                },
                }}
          >
            <Link to={item.path} style={{ textDecoration: "none", color: "inherit", width: '100%' }}>
              <ListItemButton
                onClick={isLargeScreen ? null : toggleDrawer(anchor, false)}              
              >
                <ListItemIcon sx={{color:"white"}}>{item.icon}</ListItemIcon>
                <ListItemText primary={item.text} />
              </ListItemButton>
            </Link>
          </ListItem>
        ))}

        {categories.length > 0 ? (
            categories.map((category) => (
              <div key={category.id}>
                <ListItem button onClick={() => toggleSubmenu(category.id)}>
                  <ListItemText primary={category.name} />
                  {submenuOpen[category.id] ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                {category.subcategories && category.subcategories.length > 0 && (
                  <Collapse in={submenuOpen[category.id]} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      {category.subcategories.map((subcategory) => (
                        <ListItem key={subcategory.id} sx={{ pl: 4 }}>
                          <Link
                            to={`/admin-user/sub-category/${subcategory.id}`}
                            style={{ textDecoration: "none", color: "inherit" }}
                          >
                            <ListItemText primary={subcategory.name} />
                          </Link>
                        </ListItem>
                      ))}
                    </List>
                  </Collapse>
                )}
              </div>
            ))
          ) : (
            <ListItem>
              <ListItemText primary="No categories available." />
            </ListItem>
          )}
      </List>


    </Box>
  );

  return (
    <div>
      <SideBarNavBar toggleDrawer={toggleDrawer} />
      {isLargeScreen ? (
        <Drawer
          variant="permanent"
          anchor="left"
          open
          sx={{
            '& .MuiDrawer-paper': {
              width: 250,
              boxSizing: 'border-box',
              overflowX: 'hidden', 
            },
          }}
        >
          {list("left")}
        </Drawer>
      ) : (
        <SwipeableDrawer
          anchor="top"
          open={state.top}
          onClose={toggleDrawer("top", false)}
          onOpen={toggleDrawer("top", true)}
          sx={{
            '& .MuiDrawer-paper': {
              borderBottomLeftRadius: 30,
              borderBottomRightRadius: 30,
              background: 'linear-gradient(135deg, #ffcbc9 0%, #fea5b8 30%, #e990c6 60%, #c196c1 100%)',
              overflowX: 'hidden', 
            },
          }}
        >
          {list("top")}
        </SwipeableDrawer>
      )}
    </div>
  );
}
